import { PaperTable } from "@/components";
import API from "../services/api-request";

export default {
  data() {
    return {
      heading: {
        Sites: 0,
        Hotels: 2,
        Restos: 3,
      },
      hotelBookings: [],
      tourBookings: [],
      restoBookings: [],
      //pagination
      currentPage: "",
      firstPage: 1,
      lastPage: "",
      dataIsLoad: 0,
    };
  },
  methods: {
    show(head) {
      this.dataIsLoad = 0;
      this.currentPage = 1;
      var one = 1;
      var two = 2;
      var tree = 3;
      //  var four = 4;

      switch (head) {
        case this.heading.Sites:
          this.tourBooking();
          one = 0;
          this.headTitle = "Sites";
          break;
        case this.heading.Hotels:
          this.hotelBooking();
          two = 0;
          this.headTitle = "Hotels";
          break;
        case this.heading.Restos:
          this.restoBooking();
          tree = 0;
          this.headTitle = "Restos";
          break;
        // case this.heading.Voitures:
        //   four = 0;
        //   this.headTitle = "Voitures";
        //   break;
      }
      this.heading = {
        Sites: one,
        Hotels: two,
        Restos: tree,
        // Voitures: four,
      };
    },

    tourBooking(page) {
      !page ? (page = 1) : "";

      API.index(`tour-booking?page=${page}`).then((response) => {
        this.dataIsLoad = 1;
        //pagination
        this.currentPage = response.data["meta"].current_page;
        this.lastPage = response.data["meta"].last_page;
        this.tourBookings = [];
        this.tourBookings = response.data["data"];
      });
    },
    hotelBooking(page) {
      !page ? (page = 1) : "";

      API.index(`hotel-booking?page=${page}`).then((response) => {
        this.dataIsLoad = 1;

        this.currentPage = response.data["meta"].current_page;
        this.lastPage = response.data["meta"].last_page;
        this.hotelBookings = [];
        this.hotelBookings = response.data["data"];
      });
    },
    restoBooking(page) {
      !page ? (page = 1) : "";

      API.index(`resto-booking?page=${page}`).then((response) => {
        this.dataIsLoad = 1;
        this.currentPage = response.data["meta"].current_page;
        this.lastPage = response.data["meta"].last_page;
        this.restoBookings = [];
        this.restoBookings = response.data["data"];
      });
    },
    paginate(type) {
      if (type == "previous") {
        this.currentPage > 1 ? (this.currentPage -= 1) : "";
      } else {
        this.currentPage < this.lastPage ? (this.currentPage += 1) : "";
      }
      switch (this.headTitle) {
        case "Sites":
          this.tourBooking(this.currentPage);
          break;
        case "Restos":
          this.restoBooking(this.currentPage);
          break;
        case "Hotels":
          this.hotelBooking(this.currentPage);
          break;
      }
    },
  },
  mounted() {
    this.tourBooking();
  },
};
